module.exports = __webpack_public_path__ + "media/loader_mob_def.d35cbcfa.mp4";